window.FB = window.FB || {};
const studiesApp = window.angular.module('studiesApp', ['ngCookies', 'ngTouch', 'ngCapsLock'])
    .config(function ($interpolateProvider) {
        // To prevent the conflict of `{{` and `}}` symbols
        // between Blade template engine and AngularJS templating we need
        // to use different symbols for AngularJS.

        $interpolateProvider.startSymbol('<%');
        $interpolateProvider.endSymbol('%>');
    }).controller('SiteController', ['$scope', '$http', '$window', function ($scope, $http, $window) {

        $scope.code_test = 'ok';

        $scope.purchase_mode = false;
        $scope.purchase_link = null;

        $scope.user = null;
        $scope.subscriptions = null;
        $scope.cart = {
            total: 0,
            items: []
        };

        $scope.shareFacebook = function () {
            if (typeof window.FB !== 'undefined') {
                window.FB.ui({
                    method: 'feed',
                    link: $window.location.href,
                }, function () {
                });
            }


            // $window.open('https://www.facebook.com/share.php?u=' + $window.location.href, '_blank').focus();
        }

        $scope.shareFacebookMessenger = function () {
            window.open('fb-messenger://share?link=' + encodeURIComponent($window.location.href) + '&app_id=' + encodeURIComponent('400199846752578'));
        }

        $scope.setRegisterLoginPurchaseMode = function (link) {
            $scope.$broadcast("setPurchaseMode", 'true');
            $scope.$broadcast("setPurchaseLink", link);
        }


        $scope.buyCourse = function (course) {
            if (!course) {
                course = $window.course_code;
            }
            if (!course) {
                console.log('cannot find course');
                return false;
            }

            // Submit course buy now event
            $window.dataLayer.push({
                'event': 'course_buy_click',
                'course_name': window.course_name,
                'course_code': window.course_code,
                'page_url': window.location.href
            });

            $http({
                method: 'GET',
                url: '/cart/add/course/' + course + '?r' + Math.random(),
            }).then(function successCallback() {
                $scope.$broadcast("addedItem", 'true');
                $scope.$broadcast("refreshCart", 'true');
                $scope.$broadcast("openCartModal", 'true');

            }, function errorCallback() {
                // document.location.reload();
            });
        }

        $scope.buyLesson = function (lesson) {
            $http({
                method: 'GET',
                url: '/cart/add/lesson/' + lesson + '?r' + Math.random(),
            }).then(function successCallback() {
                $scope.$broadcast("addedItem", 'true');
                $scope.$broadcast("refreshCart", 'true');
                $scope.$broadcast("openCartModal", 'true');

            }, function errorCallback() {
                // document.location.reload();
            });
        }


        $scope.shareWhatsapp = function () {
            $window.open('https://api.whatsapp.com/send/?phone&app_absent=0&text=' + $window.location.href, '_blank').focus();
        }


        $scope.logout = function () {
            $http({
                method: 'POST',
                url: '/logout',
            }).then(function successCallback() {
                document.location.href = '/';
            }, function errorCallback() {
                document.location.href = '/';
            });
        };

        $scope.init = function () {

            // Auto add course?
            if (document.location.hash === '#add-to-cart') {
                $scope.buyCourse();
            }

            $http({
                method: 'GET',
                url: '/system/me',
            }).then(function successCallback(response) {
                if (response && response.data) {
                    if (response.data.status) {
                        $scope.user = response.data.data.user;
                        $scope.subscriptions = response.data.data.subscriptions;
                    }
                }

                // Show cart?
                if (document.location.hash === "#show-cart-after-login") {
                    $scope.openCartModal();
                    document.location.hash = "";
                }
            }, function errorCallback() {
            });

            $scope.$broadcast("refreshCart", 'true');

        };

        $scope.openPaymentWindow = function ($event, url) {
            $event.preventDefault();
            $event.stopPropagation();

            // Set up
            $('.paymentSpinner').show();
            $('.paymentIframe').hide().attr('src', url);

            // Show
            $('#paymentModal').modal('show');


            setTimeout(function () {
                $('.paymentSpinner').hide();
                $('.paymentIframe').show();
            }, 3000);

        }

        $scope.$on("openRegistraionModal", function () {
            $scope.openRegistraionModal();
        });
        $scope.openRegistraionModal = function () {
            $('.modal').modal('hide');
            $('#registerModal').modal('show');
        }

        $scope.$on("openLoginModal", function () {
            $scope.openLoginModal();
        });
        $scope.openLoginModal = function () {
            $('.modal').modal('hide');
            $('#loginModal').modal('show');
        }

        $scope.$on("openFPModal", function () {
            $scope.openFPModal();
        });
        $scope.openFPModal = function () {
            $('.modal').modal('hide');
            $('#fpModal').modal('show');
        }

        $scope.$on("openCartModal", function () {
            $scope.openCartModal();
        });
        $scope.openCartModal = function () {
            $('.modal').modal('hide');
            $('#cartModal').modal('show');
        }

        $scope.init();
    }]).controller('ForumController', ['$scope', '$http', '$timeout', '$window', '$interval', function ($scope, $http, $timeout, $window, $interval) {
        $scope.post_error = null;
        $scope.submitting = false;
        $scope.message = '';

        $interval(function () {
            if ($window.tinymce) {
                $scope.message = $window.tinymce.activeEditor.getContent();
            } else {
                $scope.message = '';
            }
        }, 1000);

        $scope.formReady = function () {
            return $scope.title && $scope.title.trim().length > 0 &&
                $scope.message &&
                $scope.message.trim().length > 0
        };

        $scope.getMessageLength = function () {
            if (!$scope.message) {
                return 0;
            }
            return $scope.message.trim().length;
        }

        $scope.submit = function () {
            $scope.post_error = null;
            if ($scope.formReady()) {
                $scope.submitting = true;
                $http({
                    method: 'POST',
                    url: '/forum/submit',
                    data: {
                        message: $scope.message,
                        title: $scope.title,
                        forum_id: $window.forum_id,
                        post_id: $window.post_id,
                    }
                }).then(function successCallback(response) {
                    if (response && response.data) {
                        if (response.data.status) {
                            $scope.sent = true;
                            $window.location.href = response.data.data.url;
                        }
                    }

                    // Just in case, reset the submit button after 2 seconds.
                    $timeout(function() {
                        $scope.submitting = false;
                    }, 2000);

                }, function errorCallback() {
                    $scope.submitting = false;
                    $scope.error = true;
                });
            } else {
                if (!$scope.title || $scope.title.trim().length < 1) {
                    $scope.post_error = 'נא למלא כותרת';
                } else if (!$scope.message || $scope.message.trim().length < 1) {
                    $scope.post_error = 'תוכן הודעה ריק. נא לבדוק.';
                }
            }
        }


    }]).controller('ContactController', ['$scope', '$http', '$timeout', 'csrfHandler', function ($scope, $http, $timeout, csrfHandler) {

        $scope.sending = false;
        $scope.sent = false;
        $scope.type = 'select';
        $scope.error = false;

        $scope.errors = {
            name: false,
            email: false,
            email_again: false,
            phone: false,
            message: false
        };


        $scope.validateForm = function () {

            // Reset errors
            $scope.errors = {
                name: false,
                email: false,
                email_again: false,
                phone: false,
                message: false
            };

            $scope.errors.name = (!$scope.name || $scope.name.length < 2);
            $scope.errors.email = (!window.validateEmail($scope.email));
            $scope.errors.email_again = $scope.errors.email || $scope.email !== $scope.email_again;
            $scope.errors.phone = (!$scope.phone || $scope.phone.length !== 10);
            $scope.errors.message = (!$scope.message || $scope.message.length < 1);

            return $scope.formNotValidated();
        };


        $scope.formNotValidated = function () {
            return Object.values($scope.errors).indexOf(true) !== -1;
        }

        $scope.submit = function () {
            $scope.sent = false;


            $scope.validateForm();
            if ($scope.formNotValidated()) {
                return false;
            }

            $scope.sending = true;
            $timeout(function () {
                $scope.sending = false;
            }, 1000);

            csrfHandler().then(function (csrf) {
                $http({
                    method: 'POST',
                    url: '/contact/send',
                    data: {
                        name: $scope.name,
                        email: $scope.email,
                        phone: $scope.phone,
                        message: $scope.message,
                        type: $scope.type,
                        _token: csrf // TODO: Fix this
                    }
                }).then(function successCallback() {
                    $scope.sent = true;
                    $scope.sending = false;

                    $scope.name = '';
                    $scope.email = '';
                    $scope.email_again = '';
                    $scope.message = ''; // Reset

                }, function errorCallback() {
                    $scope.sending = false;
                    $scope.error = true;
                });
            })


        }

    }]).controller('CartController', ['$scope', '$timeout', '$window', '$http', function ($scope, $timeout, $window, $http) {

        $scope.cart_error = null;
        $scope.cart_in_progress = false;
        $scope.tried_to_add_item = false;

        $scope.init = function() {
            if ($window.cart_code_from_url) {
                $scope.coupon_code = $window.cart_code_from_url;

                setTimeout(function() {
                    $scope.updateCouponCode();
                    $scope.openCartModal();
                }, 500);
            }
        }
        $scope.init();

        $scope.loggedIn = function () {
            return $window.user_logged_in;
        }

        $scope.cartLocked = function () {
            return ($scope.getCartObject().coupon && $scope.getCartObject().coupon.type === 'package');
        }

        $scope.cartPackageLocked = function () {
            return ($scope.getCartObject().coupon && $scope.getCartObject().coupon.type === 'special_package');
        }

        $scope.coupon_code_error = null;

        $scope.getItemCount = function () {
            return $scope.getCartObject().items.length;
        }

        /**
         * Get the cart object
         * @returns {*}
         */
        $scope.getCartObject = function () {
            return $scope.$parent.cart;
        }
        /**
         * Set the cart object
         * @param cart
         * @returns {*}
         */
        $scope.setCartObject = function (cart) {
            return $scope.$parent.cart = cart;
        }

        $scope.removeItem = function (item) {
            $scope.tried_to_add_item = false;
            $http({
                method: 'POST',
                url: '/cart/remove/?t=' + Math.random(),
                data: {
                    item: item
                }
            }).then(function successCallback() {
                $scope.$broadcast("refreshCart", 'true');
            }, function errorCallback() {
                console.log('nok');
            });
        }

        $scope.checkIfCouponNotSavedYet = function () {
            if ($scope.coupon_code) {
                $scope.updateCouponCode(false, true);
                return true;
            }
            $scope.getPaymentLink(true);
        }

        $scope.getPaymentLink = function (skip_coupon_check) {
            // Stupid work around...
            if (!skip_coupon_check) {
                if ($scope.checkIfCouponNotSavedYet()) {
                    // we will get back here automatically...
                    return false;
                }
            }

            $scope.cart_error = false;
            $scope.tried_to_add_item = false;
            $scope.cart_in_progress = true;
            $timeout(function () {
                $scope.cart_in_progress = false;
            }, 5000);

            $http({
                method: 'POST',
                url: '/cart/pay?ajax=true',
            }).then(function successCallback(data) {
                if (data.data && data.data.url) {
                    $window.location.href = data.data.url;
                } else {
                    $scope.cart_in_progress = false;
                    $scope.cart_error = data.data.error;
                }
            }, function errorCallback() {
                $scope.cart_in_progress = true;
                console.log('nok');
            });
        }

        $scope.getCart = function () {
            $http({
                method: 'GET',
                url: '/cart/get?t=' + Math.random(),
            }).then(function successCallback(data) {
                if (data.data.cart) {
                    $scope.setCartObject(data.data.cart);
                }
            }, function errorCallback() {
                console.log('nok');
            });
        }

        $scope.updateCouponCode = function (remove, force_payment) {
            $scope.tried_to_add_item = false;
            $scope.coupon_code_error = null;
            if (!remove) {
                if (!$scope.coupon_code || $scope.coupon_code.trim() === '') {
                    $scope.coupon_code_error = 'נא להזין קוד';
                    return false;
                }
            }

            $http({
                method: 'POST',
                url: '/cart/coupon?t=' + Math.random(),
                data: {
                    coupon_code: $scope.coupon_code,
                    remove: remove
                }
            }).then(function successCallback(data) {
                if (data.data) {
                    if (data.data.result === false) {
                        if (remove) {
                            $window.location.reload();
                        }
                        $scope.coupon_code_error = 'קוד לא נמצא';
                    } else {
                        $scope.getCart();
                        $scope.coupon_code = '';

                        if (force_payment) {
                            // In case we come from the check coupon
                            $scope.getPaymentLink(true);
                        }
                    }
                }
            }, function errorCallback() {
                console.log('nok');
            });
        }

        $scope.$on("refreshCart", function () {
            $scope.getCart();
        });
        $scope.$on("addedItem", function () {
            $scope.tried_to_add_item = true;
        });


    }]).controller('ProfileController', ['$scope', '$http', '$window', '$cookies', function ($scope, $http) {

        $scope.profile = [];
        $scope.update_email_error = null;
        $scope.update_email_done = null;
        $scope.update_profile_pic_done = null;

        $scope.init = function () {
            $http({
                method: 'GET',
                url: '/system/me',
            }).then(function successCallback(response) {
                if (response && response.data) {
                    if (response.data.status) {
                        $scope.profile = response.data.data.user;
                        $scope.subscriptions = response.data.data.subscriptions;
                    }
                }
            }, function errorCallback() {
            });
        };

        $scope.saveEmail = function () {
            $scope.update_email_error = null;
            $scope.update_email_done = null;
            if (!$scope.profile.email || !window.validateEmail($scope.profile.email)) {
                $scope.update_email_error = 'כתובת הדואר האלקטרוני לא תקינה';
                return false;
            }

            if ($scope.profile.email !== $scope.email_again) {
                $scope.update_email_error = 'כתובות הדואר האלקטרוני לא זהות';
                return false;
            }

            $http({
                method: 'POST',
                url: '/system/me',
                data: {
                    email: $scope.email_again
                }
            }).then(function successCallback() {
                $scope.update_email_done = true;
                // $scope.email_again = '';
            }, function errorCallback() {
                $scope.update_email_error = 'שגיאה. ייתכן והכתובת מייל כבר בשימוש.';
            });
        }


        $scope.savePassword = function () {
            $scope.update_password_error = null;
            $scope.update_password_done = null;
            if (!$scope.passwordCurrent) {
                $scope.update_password_error = 'הסיסמה הנוכחית לא תקינה';
                return false;
            }

            if ($scope.passwordNew !== $scope.passwordNew2) {
                $scope.update_password_error = 'הסיסמאות החדשות לא זהות';
                return false;
            }

            $http({
                method: 'POST',
                url: '/system/me',
                data: {
                    passwordCurrent: $scope.passwordCurrent,
                    passwordNew: $scope.passwordNew
                }
            }).then(function successCallback() {
                $scope.update_password_done = true;
                $scope.passwordCurrent = null;
                $scope.passwordNew = null;
                $scope.passwordNew2 = null;
            }, function errorCallback() {
                $scope.update_password_error = 'שגיאה. נא לבדוק שהסיסמה הנוכחית נכונה ושהחדשה מעל 6 תווים';
            });
        }


        $scope.updateAvatar = function (index) {
            $scope.profile.avatar = index;

            $http({
                method: 'POST',
                url: '/system/me',
                data: {
                    avatar: index
                }
            }).then(function successCallback() {
                $scope.update_profile_pic_done = true;
            }, function errorCallback() {
            });

        }

        $scope.init();
    }])
    .controller('LORController', ['$scope', function ($scope) {
        $scope.lor = true;
    }])
    .controller('ForgotPasswordController', ['$scope', '$http', '$window', '$cookies', '$timeout', 'keyHandler', function ($scope, $http, $window, $cookies, $timeout, keyHandler) {

        $scope.resetting = false;
        $scope.fp_success_message = '';

        $scope.errors = {
            passwordNew: false,
            passwordNew2: false
        };

        $scope.validateForm = function () {

            // Reset errors
            $scope.errors = {
                passwordNew: false,
                passwordNew2: false
            };

            $scope.errors.passwordNew = (!$scope.passwordNew || $scope.passwordNew.length < 6);
            $scope.errors.passwordNew2 = $scope.errors.passwordNew || $scope.passwordNew !== $scope.passwordNew2;

            return $scope.formNotValidated();
        };

        $scope.formNotValidated = function () {
            return Object.values($scope.errors).indexOf(true) !== -1;
        }

        $scope.resetPassword = function () {

            $scope.validateForm();

            if ($scope.formNotValidated()) {
                return false;
            }

            $scope.resetting = true;
            $scope.message = '';
            $scope.fp_success_message = null;
            $scope.fp_error_message = null;

            $http({
                method: 'POST',
                url: '',
                data: {
                    email: $scope.email,
                    password: $scope.passwordNew,
                    token: keyHandler()
                }
            }).then(function successCallback(response) {
                if (response && response.data) {
                    if (response.data.status) {
                        $scope.fp_success_message = 'הסיסמה שונתה בהצלחה';
                        $scope.passwordNew = '';
                        $scope.passwordNew2 = '';
                        $timeout(function () {
                            document.location.href = '/';
                        }, 2500);
                    } else {
                        $scope.fp_error_message = response.data.error;
                    }
                    $scope.resetting = false;
                }
            }, function errorCallback() {
                $scope.resetting = false;
                $scope.fp_error_message = 'משתמש לא נמצא';
            });

        }


        $scope.formReady = function () {
            return !(!$scope.passwordNew ||
                !$scope.passwordNew2 ||
                $scope.passwordNew !== $scope.passwordNew2 ||
                $scope.passwordNew.length < 6
            );
        };

    }])
    .controller('RegistrationController', ['$scope', '$http', '$window', '$cookies', 'keyHandler', function ($scope, $http, $window, $cookies, keyHandler) {

        $scope.errors = {
            first_name: false,
            last_name: false,
            email: false,
            email_again: false,
            password: false,
            password_again: false,
            accept_tc: false
        };

        $scope.validateForm = function () {

            // Reset errors
            $scope.errors = {
                first_name: false,
                last_name: false,
                email: false,
                email_again: false,
                password: false,
                password_again: false,
                accept_tc: false
            };

            $scope.errors.first_name = (!$scope.first_name || $scope.first_name.length < 2);
            $scope.errors.last_name = (!$scope.last_name || $scope.last_name.length < 2);
            $scope.errors.email = (!window.validateEmail($scope.email));
            $scope.errors.email_again = $scope.errors.email || $scope.email !== $scope.email_again;
            $scope.errors.password = (!$scope.password || $scope.password.length < 6);
            $scope.errors.password_again = $scope.errors.password || $scope.password !== $scope.password_again;
            $scope.errors.accept_tc = (!$scope.accept_tc);


            return $scope.formNotValidated();
        };

        $scope.formNotValidated = function () {
            return Object.values($scope.errors).indexOf(true) !== -1;
        }


        $scope.register = function () {
            // True means not validated, because of formNotValidated response
            if ($scope.validateForm()) {
                return false;
            }

            $scope.login_error = false;
            $scope.email_in_use_error = false;
            $scope.register_in_progress = true;

            $http({
                method: 'POST',
                url: '/user/register?r=' + Math.random(),
                data: {
                    email: $scope.email,
                    password: $scope.password,
                    first_name: $scope.first_name,
                    last_name: $scope.last_name,
                    token: keyHandler()
                }
            }).then(function successCallback(response) {
                if (response && response.data) {
                    if (response.data.status) {

                        // Reload
                        setTimeout(function () {
                            if (response.data.has_cart) {
                                document.location.hash = "show-cart-after-login";
                                document.location.reload();
                            } else {
                                document.location.reload();
                            }
                        }, 500);

                    } else {
                        if (response.data.error === 'Email Taken') {
                            $scope.email_in_use_error = true;
                        } else {
                            $scope.login_error = true;
                        }
                        $scope.register_in_progress = false;
                    }
                }
            }, function errorCallback() {
                $scope.login_error = true;
                $scope.register_in_progress = false;
            });
        };

        $scope.formReady = function () {
            return !(!$scope.email ||
                !$scope.password ||
                !$scope.first_name ||
                !$scope.last_name ||
                $scope.email.length < 5 ||
                $scope.password < 5 ||
                $scope.password !== $scope.password_again ||
                $scope.email !== $scope.email_again ||
                !$scope.accept_tc
            );
        };

    }])
    .controller('LoginController', ['$scope', '$http', '$window', '$cookies', 'keyHandler', function ($scope, $http, $window, $cookies, keyHandler) {

        $scope.fp_error_message = null;
        $scope.resetting = false;
        $scope.fp_success_message = null;

        $scope.login_error = false;
        $scope.login_error_message = null;
        $scope.show_reset_link = false;
        $scope.reset_cookie_key = null;
        $scope.logging_in = false;
        $scope.purchase_mode = false;
        $scope.purchase_link = null;

        $scope.reAuthorizeComputer = function ($event) {
            $event.stopPropagation();

            $http({
                method: 'POST',
                url: ''
            }).then(function successCallback(response) {
                if (response && response.data) {
                    if (response.data.status) {
                        if (response.data.sitekey) {
                            keyHandler(response.data.sitekey);
                        }

                        document.location.reload();
                    }
                }
            }, function errorCallback() {
                $scope.authorizeComputerClicked = false;
            });
        }


        $scope.resetPassword = function () {

            $scope.fp_error_message = null;

            if (!$scope.fpFormReady()) {
                $scope.fp_error_message = 'המייל שהוזן לא תקין';
                return false;
            }

            $scope.resetting = true;
            $scope.message = '';
            $scope.fp_success_message = null;

            $http({
                method: 'POST',
                url: '/user/reset-password',
                data: {
                    email: $scope.email,
                    token: keyHandler()
                }
            }).then(function successCallback(response) {
                if (response && response.data) {
                    if (response.data.status) {
                        $scope.email = '';
                        $scope.fp_success_message = 'נשלח מייל לאיפוס סיסמא. אם לא קיבלתם, בדקו בספריית הספאם.';
                    } else {
                        $scope.fp_error_message = response.data.error;
                    }
                    $scope.resetting = false;
                }
            }, function errorCallback() {
                $scope.resetting = false;
                $scope.fp_error_message = 'משתמש לא נמצא';
            });

        }

        // $scope.openLoginModal();

        $scope.login = function () {

            if (!$scope.formReady()) {
                $scope.login_error = true;
                $scope.login_error_message = 'נא לבדוק פרטי חיבור';
                return false;
            }

            $scope.login_error_message = null;
            $scope.show_reset_link = false;
            $scope.login_error = false;
            $scope.reset_cookie_key = null;
            $scope.logging_in = true;


            $http({
                method: 'POST',
                url: '/user/login-ajax?t=' + Math.random(),
                data: {
                    email: $scope.email,
                    password: $scope.password,
                    token: keyHandler()
                }
            }).then(function successCallback(response) {
                if (response && response.data) {
                    if (response.data.status) {
                        if (response.data.sitekey) {
                            keyHandler(response.data.sitekey);
                        }

                        $window.dataLayer.push({
                            'event': 'site_login_success',
                            'custom_value': $scope.email
                        });

                        // Reload
                        setTimeout(function () {
                            if (response.data.has_cart) {
                                $window.dataLayer.push({
                                    'event': 'site_login_had_cart',
                                    'custom_value': $scope.email
                                });
                                document.location.hash = "show-cart-after-login";
                                document.location.reload();
                            } else {
                                document.location.reload();
                            }
                        }, 500);

                    } else {
                        if (response.data.reset_cookie === true && response.data.reset_cookie_key) {
                            $window.dataLayer.push({
                                'event': 'site_do_reauthorize_computer',
                                'custom_value': $scope.email
                            });
                            $window.location.href = '/user/re-authorize-computer/' + response.data.reset_cookie_key;
                            return false;
                        }
                        if (response.data.can_reset && response.data.can_reset === 'no') {
                            $('#loginModal').modal('hide');
                            $('#lockedModal').modal('show');
                        }
                        $scope.login_error_message = response.data.error;
                        $scope.login_error = true;
                        $scope.logging_in = false;
                    }
                }
            }, function errorCallback() {
                $window.dataLayer.push({
                    'event': 'site_login_error',
                    'custom_value': $scope.email
                });

                $scope.login_error_message = 'נא לפנות לתמיכה';
                $scope.logging_in = false;
                $scope.login_error = true;
            });
        };

        $scope.fpFormReady = function () {
            if ($scope.resetting) {
                return false;
            }
            return !(!$scope.email || !window.validateEmail($scope.email));
        };

        $scope.formReady = function () {
            if ($scope.logging_in) {
                return false;
            }
            return !(!$scope.email || !window.validateEmail($scope.email) || !$scope.password || $scope.email.length < 5 || $scope.password < 5);
        };

    }])
    .controller('FilterController', ['$scope', '$http', '$window', '$interval', '$timeout', function ($scope, $http, $window, $interval, $timeout) {
        $scope.items = [];
        $scope.site = 'ee';


        $scope.getDataOrPlaceholder = function (item) {
            if (!item || item.length === 0) {
                return [{name: 'xxx'}];
            }
            return item;
        }
        $scope.filterReady = false;
        $scope.getItems = function () {
            $timeout(function () {
                $http({
                    method: 'GET',
                    url: '/system/filter'
                }).then(function successCallback(response) {
                    if (response && response.data) {
                        if (response.data.status) {
                            $scope.items = response.data.items;
                            window.angular.forEach(response.data.items, function (item) {
                                if (!item.site_enabled) {
                                    delete response.data.items[item.id];
                                }
                            })
                            if ($window.__studies_top_search_bar_site_id) {
                                $scope.site = $scope.items[$window.__studies_top_search_bar_site_id];
                            } else {
                                $scope.site = $scope.items[0];
                            }
                            $scope.filterReady = true;
                        }
                    }
                }, function errorCallback() {
                });
            }, 5000);

        }

        $scope.removeFirst = function () {
            if ($scope.items[0]) {
                delete $scope.items[0];
            }
        }

        $scope.goToCourse = function () {
            $window.location.href = $scope.course.url;
        }

        $scope.getItems();
    }])

    .controller('PlayerV2Controller', ['$scope', '$http', '$window', '$timeout', '$interval', 'keyHandler', function ($scope, $http, $window, $timeout, $interval, keyHandler) {

        $scope.playerReady = false;
        $scope.clips = [];
        $scope.mobileMenu = false;
        $scope.active_clip = null;
        $scope.iframe = null;
        $scope.player = null;
        $window.player = $scope.player;
        $scope.captionsOnOff = 1;
        $scope.playerSpeed = 1;
        $scope.eventListenersSet = false;
        $scope.skip_to_last_viewed = false;

        $scope.VdoPlayerReadyInterval = null;
        $scope.authorizeComputerClicked = false;

        $scope.captionsLength = 1;

        $scope.showPlayerMobileMenu = function (val) {
            $scope.mobileMenu = val;
        }

        $interval(function () {
            // check that $window.player.api exists before trying
            if ($window.player && $window.player.api) {
                $window.player.api.getCaptionLanguages().then(function (res) {
                    $scope.captionsLength = res.languages.length;
                });
            };
        }, 1000);

        // Check captions state
        $scope.captionsOnOff = ($window.studiesPlayer) ? $window.studiesPlayer.getCaptionsStateFromConfig() : true;

        $scope.changeCaptions = function(state) {
            console.log('changing captions: ' + state);
            $window.studiesPlayer.setConfig('captionsEnabled', state);
            $scope.captionsOnOff = state;
            if (state === 0) {
                $window.player.api.hideCaptions();
            } else {
                $window.player.api.setCaptionLanguage('he');
            }
        }

        // Check player speed
        $scope.playerSpeed = ($window.studiesPlayer) ? $window.studiesPlayer.getConfig('playbackRate') : 1;

        $scope.changePlayerSpeed = function(speed) {
            $window.player.video.defaultPlaybackRate = speed;
            $window.player.video.playbackRate = speed;
            $scope.playerSpeed = speed;
            $window.studiesPlayer.setConfig('playbackRate', speed);

            // Send event to GA
            $window.dataLayer.push({
                'event': 'site_change_speed',
                'new_speed': speed,
                'course_id': $window.course_id,
                'lesson_id': $window.lesson_id,
                'page_url': $window.location.href
            });
        }

        $scope.authorizeComputer = function () {
            $scope.authorizeComputerClicked = true;

            $http({
                method: 'POST',
                url: '/user/authorize-computer'
            }).then(function successCallback(response) {
                if (response && response.data) {
                    if (response.data.status) {
                        if (response.data.sitekey) {
                            keyHandler(response.data.sitekey);
                        }
                        $window.location.reload();
                    }
                }
            }, function errorCallback() {
                $scope.authorizeComputerClicked = false;
            });
        }

        $scope.setPlayerReady = function () {
            $timeout(function () {
                $scope.playerReady = true;
            }, 2000);
        }

        $scope.getLesson = function (get_recently_watched = false) {
            const lesson_id = window.lesson_id;
            const course_id = window.course_id;
            if (!lesson_id) {
                return;
            }
            if (!course_id) {
                return;
            }

            $http({
                method: 'GET',
                url: '/player/lesson/' + lesson_id + '/' + course_id + '?r' + Math.random()
            }).then(function successCallback(response) {
                if (response && response.data) {
                    if (response.data.status) {
                        $scope.clips = response.data.clips;
                        if ($window.user_logged_in) {
                            if (get_recently_watched) {
                                let found = false;
                                window.angular.forEach($scope.clips, function (clip, index) {
                                    // I put 98 because sometimes the user can watch 98% of the clip, and it will be considered as watched
                                    if (!found && clip.progress < 98) {
                                        found = true;
                                        $scope.getClip($scope.clips[index].key, true);
                                    }
                                });
                                if (!found) {
                                    // If we didn't find a clip that is not watched, play the first clip
                                    $scope.getClip($scope.clips[0].key);
                                }
                                //$scope.getClip($scope.clips[0].key);
                            } else {
                                // If we didn't set the recently watched, play the first clip
                                $scope.getClip($scope.clips[0].key);
                            }
                        } else {
                            // If user is not logged in, play the first clip
                            $scope.getClip($scope.clips[0].key);
                        }
                    }
                }
            }, function errorCallback() {
            });
        };

        $scope.getClip = function (clip_id = null) {
            $http({
                method: 'GET',
                url: '/player/clip/' + clip_id + '/studies-clip-' + Math.random()
            }).then(function successCallback(response) {

                // Set active
                $window.angular.forEach($scope.clips, function (clip) {
                    if (clip.key === clip_id) {
                        $scope.setActive(clip);
                        $window.clip_name = clip.name;
                        $scope.setPlayerReady();
                    }
                })

                if (response && response.data) {
                    if (response.data.status) {
                        // $scope.play(response.data.clip, jump_to_time);
                        $scope.loadVideo(response.data.clip.otp, response.data.clip.playbackInfo);
                    }
                }
            }, function errorCallback() {
            });
        }

        $scope.loadVideo = function (otp, playbackInfo) {
            $scope.skip_to_last_viewed = false;

            if ($scope.iframe.src.length === 0) {
                // First time load, we need to force the iframe to load the video
                $scope.iframe.src = 'https://player.vdocipher.com/v2/?otp=' +
                    otp +
                    '&playbackInfo=' + playbackInfo +
                    '&player=NAp6rqA7m0l8WqwN' +
                    '&primaryColor=' + $window.primary_color;
            } else {
                // console.log('other time');
                // We can just load the video normally
                $scope.player.api.loadVideo({otp, playbackInfo});
            }


            $scope.player = $window.VdoPlayer.getInstance($scope.iframe);
            $scope.setPlayerReady();

            $window.current_video_max_percentage = 0;
            // Add event listeners if they are not set
            if (!$scope.eventListenersSet) {
                $scope.eventListenersSet = true;

                if ($scope.active_clip.progress && $scope.active_clip.progress > 0) {
                    $scope.player.video.addEventListener('canplay', () => {
                        if (!$scope.skip_to_last_viewed) {
                            $scope.skip_to_last_viewed = true;
                            if ($scope.active_clip.progress < 98) {
                                $scope.player.video.currentTime = $scope.getApproxTime($scope.active_clip.progress, $scope.player.video.duration);
                            }
                        }
                    });
                }

                $scope.player.video.addEventListener('timeupdate', () => {
                    if (!$window.user_logged_in) {
                        return;
                    }

                    let current_video_percentage = Math.round($scope.player.video.currentTime / $scope.player.video.duration * 100);

                    // console.log('progress update: ' + current_video_percentage, $window.current_video_max_percentage);

                    if (current_video_percentage > window.current_video_max_percentage) {
                        window.current_video_max_percentage = current_video_percentage;

                        // Update progress on current video
                        if ($scope.active_clip.progress < current_video_percentage) {
                            $scope.active_clip.progress = current_video_percentage;
                        }

                        $http({
                            method: 'POST',
                            url: '/user/update-video-progress',
                            data: {
                                percent: window.current_video_max_percentage,
                                name: $scope.active_clip.name,
                                lesson: $window.lesson_id,
                                course: $window.course_id
                            },
                        });
                    }
                });

                $scope.player.video.addEventListener('ended', () => {
                    $scope.goToNextVideo();
                });
            }

            $window.player = $scope.player;
        }

        $scope.removeActive = function () {
            $window.angular.forEach($scope.clips, function (clip) {
                clip.active = false;
            })
        }

        $scope.setActive = function (clip) {
            $scope.active_clip = clip;
            $scope.removeActive();
            clip.active = true;
        }

        $scope.select = function () {
            if (!$scope.playerReady) { return; }
            if (!$window.playlist_drag) {
                $scope.getClip(this.clip.key);
            }
        }

        $scope.getApproxTime = function (percentage, time) {
            return Math.round((percentage / 100) * time);
        }

        $scope.play = function (clipInfo, jump_to_time = false) {

            $window.video = new $window.VdoPlayer({
                otp: clipInfo.otp,
                playbackInfo: clipInfo.playbackInfo,

                theme: "9ae8bbe8dd964ddc9bdb932cca1cb59a",
                container: document.querySelector("#embedBox"),
                plugins: [{
                    name: 'keyboard',
                    options: {
                        fullscreen: true,
                        bindings: {
                            'Space': () => ($window.studiesPlayer.player().status === 1) ? $window.studiesPlayer.player().pause() : $window.studiesPlayer.player().play(),
                            'Up': () => $window.studiesPlayer.playbackrate(1),
                            'Down': () => $window.studiesPlayer.playbackrate(-1),
                            'Left': () => $window.studiesPlayer.player().seek($window.studiesPlayer.player().currentTime - $window.studiesPlayer.seek_time),
                            'Right': () => $window.studiesPlayer.player().seek($window.studiesPlayer.player().currentTime + $window.studiesPlayer.seek_time),
                        },
                    }
                }]
            });

            // All events: ended play playing pause pausing ratechange seeked seeking timeupdate volumechange

            // Do this every second

            $window.video.addEventListener('ratechange', function () {
                window._.delay(function () {
                    window.studiesPlayer.volume(window.studiesPlayer.playbackrate());
                }, 500);
            });


            // Volume change - no muted option.
            $window.video.addEventListener('volumechange', function () {
                window._.delay(function () {
                    window.studiesPlayer.volume(window.studiesPlayer.volume());
                }, 500);
            });

            $window.video.addEventListener('mediaqualitychanged', function () {
                console.log('mediaqualitychanged');
            });

            $window.video.addEventListener('pause', function () {
                console.log('pause');
            });

            $window.video.addEventListener('playing', function () {
                console.log('playing');
            });

            $window.video.addEventListener('pausing', function () {
                console.log('pausing');
            });

            // On End
            $window.video.addEventListener('ended', function () {
                $scope.goToNextVideo();

                $('.p-selector-clips').animate({
                    scrollTop: $('.p-selector-clips').scrollTop() + $('.clip.active').position().top - 30
                }, 300);
            })

            // On Loaded
            $window.video.addEventListener('load', function () {

                $window.studiesPlayer.setup();
                try {
                    if (jump_to_time) {
                        console.log('jumping to time');
                        $window.studiesPlayer.player().seek($scope.getApproxTime($scope.active_clip.progress, $window.studiesPlayer.player().duration));
                    }

                    $window.studiesPlayer.player().play();
                } catch (e) {
                    console.log('error, couldn\'t play video');
                }


                if ($window.changeSpeed) {
                    $window.changeSpeed('');
                }
                if ($window.changeVolume) {
                    $window.changeVolume('');
                }

                if ($window.studiesPlayer.userSettings.config.captionEnabled !== 'undefined') {
                    $window.video.captionEnabled = !!$window.studiesPlayer.userSettings.config.captionEnabled;
                }
            })

            // Progress bar update in real time
            if ($window.user_logged_in) {
                $window.current_video_max_percentage = 0;
            }
        };

        $scope.goToNextVideo = function () {
            let current_index = $scope.clips.indexOf($scope.active_clip);
            let total_clips = $scope.clips.length;
            if (current_index + 1 < total_clips) {
                $scope.getClip($scope.clips[current_index + 1].key);
            }
        }

        $scope.initPlayer = function () {
            $scope.iframe = document.querySelector('#vdo-ifr');
            $scope.VdoPlayerReadyInterval = $interval(function () {
                if (!$window.VdoPlayer) {
                    return;
                }
                $interval.cancel($scope.VdoPlayerReadyInterval);
                $scope.getLesson(true);
            }, 500);
        };

        $scope.initPlayer();

    }]);


studiesApp.directive('ngConfirmClick', [
    function () {
        return {
            link: function (scope, element, attr) {
                let msg = attr.ngConfirmClick || "Are you sure?";
                let clickAction = attr.confirmedClick;
                element.bind('click', function () {
                    if (window.confirm(msg)) {
                        document.location.href = clickAction;
                    }
                });
            }
        };
    }])


studiesApp.factory('keyHandler', ['$window', '$cookies', function ($window, $cookies) {
    return function (key = '') {
        if (key.length === 0) {
            console.log('Getting key!');
            let sitekey = '';
            if ($window.localStorage.getItem('sitekey')) {
                sitekey = $window.localStorage.getItem('sitekey');
            } else if ($cookies.get('sitekey')) {
                sitekey = $cookies.get('sitekey');
            }

            return sitekey;
        } else {
            // Save key
            console.log('Saving key!');
            $window.localStorage.setItem('sitekey', key);

            let expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 90);
            $cookies.put('sitekey', key, {'expires': expireDate, path: '/', domain: '.studies.co.il'});
        }
    };
}]);

studiesApp.factory('csrfHandler', ['$window', '$http', '$q', function ($window, $http, $q) {
    return function () {
        let myPromise = $q.defer();

        $http({
            method: 'POST',
            url: '/api/csrf'
        }).then(function successCallback(data) {
            myPromise.resolve(data.data);
        }, function errorCallback() {
            return null;
        });

        return myPromise.promise;
    };
}]);
